// extracted by mini-css-extract-plugin
export default {"talentBlurcontainer":"style_talentBlurcontainer__XLPHH","talentBlurWrapper":"style_talentBlurWrapper__-exzB","viewMore":"style_viewMore__oHQ5v"};